import { LocalDataStore } from "./LocalDataStore";
import { CountryProvider } from "../DataProviders/CountryProvider";
import { GeoProvider } from "../DataProviders/GeoProvider";
import { PlaceTable } from "../backend/graphql/PlaceTable";
import { WarningTable } from "../backend/graphql/WarningTable";
import { UserTable } from "../backend/graphql/UserTable";
import { NoOpDataProvider } from "./NoOpDataProvider";
import { PlaceMediaTable } from "../backend/graphql/PlaceMediaTable";
import { PlaceReportTable } from "../backend/graphql/PlaceReportTable";

export function createGraphQLDataStore(): LocalDataStore {
    const store = new LocalDataStore();
    const placeMedia = new PlaceMediaTable({ name: "place-media", store });
    const placeReport = new PlaceReportTable({ name: "place-report", store });
    store.addSource(placeMedia);
    store.addSource(placeReport);
    store.addSource(new UserTable({ name: "users", store }));
    store.addSource(new PlaceTable({ name: "places", store }, placeMedia, placeReport));
    store.addSource(new GeoProvider({ name: "geometry", store }));
    store.addSource(new CountryProvider({ name: "countries", store }));
    store.addSource(new WarningTable({ name: "warnings", store }));
    store.addSource(new NoOpDataProvider({ name: "journals", store }));
    store.addSource(new NoOpDataProvider({ name: "ground-water", store }));
    store.addSource(new NoOpDataProvider({ name: "user-filters", store }));
    store.addSource(new NoOpDataProvider({ name: "public-filters", store }));
    store.addSource(new NoOpDataProvider({ name: "place-filters", store }));
    store.addSource(new NoOpDataProvider({ name: "moderation-requests", store }));

    return store;
}
